import React, { useEffect, useState } from 'react';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';

export type BulkReferDropdownButtonProps = {
  bulkReferringLength: number;
  onClickSave: () => void;
  onClickCancel: () => void;
};

export const BulkReferDropdownButton = ({
  bulkReferringLength,
  onClickSave,
  onClickCancel,
}: BulkReferDropdownButtonProps) => {
  const [menuItems,setMenuItems]=useState<any[]>([]);
  useEffect(()=>{
if(bulkReferringLength>0){
  setMenuItems([
    {
      title: 'Refer',
      onClick: () => {
        onClickSave();
      },
      icon: <IconSymbol icon="save" />,
    },
    {
      title: 'Cancel bulk refer',
      icon: <IconSymbol icon="cancel" />,
      onClick: () => {
        onClickCancel();
      },
    },
  ]);
}else{
  setMenuItems([]);
}
  },[bulkReferringLength])
  return (
    <div>
      <React.Fragment>
        <Layout.Group>
          <DropdownMenu
            outline
            label={`Bulk refer (${bulkReferringLength})`}
            before={<IconSymbol icon="view_cozy" />}
            menuItems={menuItems}
            isDisabled={bulkReferringLength === 0}
            css={{ 'abyss-button-root': { borderRadius: 0 }, 'abyss-dropdown-menu-trigger-root': { borderRadius: 0 } }}
          />
        </Layout.Group>
      </React.Fragment>
    </div>
  );
};

